import CheckoutPanel from 'checkout/components/CheckoutPanel'
import GuestShippingAddressForm from 'checkout/components/ShippingAddressPanel/GuestShippingAddressForm'
import NewShippingAddressForm from 'checkout/components/ShippingAddressPanel/NewShippingAddressForm'
import SavedShippingAddressForm from 'checkout/components/ShippingAddressPanel/SavedShippingAddressForm'
import ShippingAddressSummary from 'checkout/components/ShippingAddressPanel/ShippingAddressSummary'
import { AddressFormContextProvider } from 'checkout/containers/AddressFormContextProvider'
import { useCheckoutContext } from 'checkout/containers/CheckoutContextProvider'
import { useEffect, useState } from 'react'
import { useShoppingRegionContext } from 'shared/contexts/ShoppingRegionContextProvider'
import { CheckoutQA } from 'shared/dataAttributes'
import { t } from 'localization'

const TP = 'checkout.components.ShippingAddressPanel.ShippingAddressPanel'

const ShippingAddressPanel = () => {
  const {
    editPanel,
    order,
    panels: { shippingAddress },
  } = useCheckoutContext()

  const getExpandedContent = () => {
    switch (shippingAddress.view) {
      case 'guest':
        return <GuestShippingAddressForm />
      case 'new':
        return <NewShippingAddressForm />
      case 'saved':
        return <SavedShippingAddressForm />
    }
  }

  const [suggestAddressEdit, setSuggestAddressEdit] = useState<boolean>(false)
  const { country: selectedCountryCode, setIsOrderPriceUpdated } = useShoppingRegionContext()
  const [prevPrice, setPrevPrice] = useState<number>()
  const price = order?.productPrice.localizedValue || 0
  const isAnyShippingAddressInRegion = !!(
    order?.shippingAddresses &&
    order?.shippingAddresses.find(a => a.countryCode === selectedCountryCode)
  )

  if (shippingAddress.view === 'saved' && !isAnyShippingAddressInRegion && !suggestAddressEdit) {
    editPanel('shippingAddress')
    setSuggestAddressEdit(true)
  }

  useEffect(() => {
    if (price) {
      if (price !== prevPrice && prevPrice) {
        setIsOrderPriceUpdated(true)
      }
      setPrevPrice(price)
    }
  }, [price])

  return (
    <AddressFormContextProvider>
      <CheckoutPanel
        title={t(`${TP}.shippingAddress`, 'Shipping Address')}
        name="shippingAddress"
        qaAttr={CheckoutQA.ShippingAddress}
        expandedContent={getExpandedContent()}
        summarizedContent={<ShippingAddressSummary />}
      />
    </AddressFormContextProvider>
  )
}

export default ShippingAddressPanel
